<script setup>
import axios from 'axios'
import { ref, onMounted } from 'vue'

import Articles from "@/components/molecules/ArticlesMolecule.vue"

axios.defaults.headers.common = {
  'X-Requested-With': 'XMLHttpRequest',
};

const data = ref()

const getData = async() => {
  await axios.get("./php/getLatestWeeklyWashigumi.php")
  .then((response) => {
    data.value = response.data
  })
}

onMounted(() => {
  getData()
})
</script>

<template>
  <h2>週刊鷲組</h2>
  <Articles :articlesData="data" />
</template>

<style scoped>
</style>